export default __webpack_public_path__ + "images/combination-lock.e6f3ee55c68719c5d19f54f60e34cf31.png";